import theme from '../../../theme';

// Frosted card floated over a Leaflet map — the Global view's stats chip and
// the single-route view's visited-order panel share it. Callers add their own
// position offsets, size and content styles. `zIndex` clears Leaflet's panes
// (400) and controls (800), which share the stacking context.
export default function mapOverlayCard() {
  return {
    position: 'absolute',
    zIndex: 1000,
    background: `${theme.colors.white}EB`,
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    border: `1px solid ${theme.colors.borderLight}`,
    borderRadius: theme.radii.inner,
    boxShadow: theme.shadows.card,
  };
}
